import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';
import { ContactApiModel } from 'app/models/contact-api.model';

@Injectable()
export class MwContactsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/transport/v1/Companies/{companyId}/Contacts';

  load(
    loadOptions?: MwLoadOptions
  ): Observable<MwPayloadModel<ContactApiModel[]>> {
    let params = loadOptions
      ? this.loadOptionsService.buildQuery(loadOptions)
      : '';

    if (params) {
      params = '?' + params;
    }

    return this.http.authGet<MwPayloadModel<ContactApiModel[]>>(
      `${this.apiEndpoint}${params}`
    );
  }

  create(contact: ContactApiModel): Observable<ContactApiModel> {
    return this.http.authPost<ContactApiModel>(this.apiEndpoint, {
      body: contact,
    });
  }

  update(contact: ContactApiModel): Observable<any> {
    return this.http.authPut<ContactApiModel>(this.apiEndpoint, {
      body: contact,
    });
  }

  delete(contact: ContactApiModel[]): Observable<any> {
    if (!(contact instanceof Array)) {
      contact = [contact];
    }
    return this.http.authDelete<ContactApiModel[]>(this.apiEndpoint, {
      body: contact,
    });
  }
}
